import type { FunctionComponent } from 'react';
import type { Person } from '@domain/person';
import { EuiFlexGroup, EuiFlexItem } from '@elastic/eui';
import GrantVrm from './grant-vrm';
import RevokeAll from './revoke-all';
import ForceLogout from './force-logout';
import SuspendLogin from './suspend-login';

interface QuickActionsProps {
  person: Person;
}

const QuickActions: FunctionComponent<QuickActionsProps> = ({ person }) => {
  const { idnumber } = person;

  const suspended = person.authn?.suspended ?? false;

  return (
    <>
      <EuiFlexGroup direction="row" responsive={false} gutterSize="s" wrap>
        {!suspended && (
          <EuiFlexItem grow={false}>
            <GrantVrm idnumber={idnumber} />
          </EuiFlexItem>
        )}
        <EuiFlexItem grow={false}>
          <ForceLogout person={person} />
        </EuiFlexItem>
        <EuiFlexItem grow={false}>
          <RevokeAll person={person} />
        </EuiFlexItem>
        {!suspended && (
          <EuiFlexItem grow={false}>
            <SuspendLogin person={person} />
          </EuiFlexItem>
        )}
      </EuiFlexGroup>
    </>
  );
};

export default QuickActions;
